export default "__VITE_ASSET__DGMcdWGu__"